// Write your JavaScript code.

var dropdownHandler = {
  init: function ($toggleButtons) {
    $toggleButtons.each(function () {
      $(this).on("click", function (e) {
        e.preventDefault();

        var dropdownSelector = $(this).data("target");
        $(dropdownSelector).attr(
          "data-state",
          $(dropdownSelector).attr("data-state") === "open" ? "closed" : "open"
        );
      });
    });

    var closeDropDown = function (e) {
        var $languageDropdown = $("#cultureList");

        if (
            $languageDropdown !== null &&
                $languageDropdown !== undefined &&
                $languageDropdown.attr("data-state") === "open" &&
                !$(e.target).hasClass("dropdown-toggle")
        ) {
            $languageDropdown.attr("data-state", "closed");
        }
    }

    $("body").on("click", closeDropDown);
    $("body").on("keypress", closeDropDown);
  },
};

(function () {
  $(document).ready(function () {
    $("#selectLanguage select").change(function () {
      $(this).parent().submit();
    });

    var $toggleButtons = $(".dropdown-toggle");
    dropdownHandler.init($toggleButtons);

      var setLanguage = function () {
          $.ajax({
              type: "POST",
              url: "/Home/SetLanguage",
              data: {
                  culture: $(this).data("id"),
                  returnUrl: "/Account/Login",
              },
              success: function() {
                  location.reload(); // alert('success');
              },
              error: function(xhr, ajaxOptions, thrownError) {
                  alert(
                      '@Url.Action("SetLanguage", "Home")' +
                      char(13) +
                      xhr.status +
                      " " +
                      thrownError
                  );
              },
          });
      }


      $("#cultureList li").click(setLanguage);
      $("#cultureList li").keypress(setLanguage);

    if (document.getElementById("preferredLanguageExternal")) {
      document.getElementById("preferredLanguageExternal").onchange =
        function () {
          this.form.submit();
        };
    }
  });
  
  $('.button-newSisLayout--goBackInHistory').on('click', function(e) {
      e.preventDefault(); // Avoid default hash link
      
      history.back();
  });

  $('.button-newSisLayout--goBackInHistory').on('keypress', function (e) {
      e.preventDefault(); // Avoid default hash link

      history.back();
  });


  var dataLanguage = $("html").attr("data-language");
  $("html").attr("lang", dataLanguage);

})();
